import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import './SignInSSO.css';
import { SSORequest } from '../../AuthenticationApiActions';
import { signIn } from '../../AuthenticationActions';
import Auth from '../../../../utils/Auth';
import GenaLoader from '../../../../utils/components/GenaLoader/GenaLoader';

const SignInSSO = ({ location, onSSOLogin, history,dispatch,onSignIn }) => {
  
   useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const jwt = searchParams.get('jwt');

    if (jwt) {
      onSSOLogin(jwt)
        .then((res) => {
          onSignIn(res);
          let { user } = res;
          Auth.login(user);
            history.push('/')
        })
        .catch(err => {
            console.error('SSO login failed:', err);
        });
    }
}, [location.search]);

return (
    <div className='loader-container'>
      <GenaLoader showLoader={true} />
    </div>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    onSSOLogin: (jwtToken) => {
      return dispatch(SSORequest(jwtToken))
        .then((res) => Promise.resolve(res))
        .catch((error) => Promise.reject(error));
    },
    onSignIn: (data) => dispatch(signIn(data)),
  };
};
export default withRouter(connect(null, mapDispatchToProps)(SignInSSO));

